export default "__VITE_ASSET__1f0c8bff__"